import React from 'react'
import { SurfacePalette } from '../../tokens'

interface Props {
  palette: SurfacePalette
  /** Total number of pages including the cover. */
  count: number
  current: number
  onJump: (index: number) => void
  labels: string[]
}

/**
 * Bottom progress strip — one segment per page (cover + sections).
 * Done = accent, active = full-opacity text color, upcoming = dim. Clicking a
 * segment jumps to that page.
 */
export const PresentProgress = ({ palette, count, current, onJump, labels }: Props) => (
  <div
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      gap: 6,
      padding: '16px 24px',
    }}
  >
    {Array.from({ length: count }).map((_, i) => {
      const color = i < current ? palette.accent : i === current ? palette.text : palette.hairline
      return (
        <button
          key={i}
          type="button"
          onClick={() => onJump(i)}
          aria-label={`Go to ${labels[i] ?? `page ${i + 1}`}`}
          aria-current={i === current}
          title={labels[i]}
          style={{
            flex: 1,
            height: 4,
            padding: 0,
            border: 'none',
            borderRadius: 2,
            background: color,
            opacity: i === current ? 1 : i < current ? 0.85 : 1,
            cursor: 'pointer',
            transition: 'background 200ms ease',
          }}
        />
      )
    })}
  </div>
)
